var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemps4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.03 24.6396C214.46 23.4896 211.99 22.8997 208.26 22.8997C197.56 22.8997 191.84 29.8097 191.84 41.6697C191.84 50.0697 195.82 57.1497 205.64 57.1497C213.48 57.1497 219.05 52.8597 219.05 45.1697C219.05 37.4797 213.44 34.2396 207.23 34.2396C203.98 34.2396 201.37 35.4397 200.03 37.0597C200.83 27.8697 210.75 28.6797 216.42 31.3297L217.03 24.6396ZM205.74 40.4896C208.7 40.4896 211.07 42.5197 211.07 45.4097C211.07 48.2997 208.7 50.3297 205.74 50.3297C202.78 50.3297 200.42 48.2997 200.42 45.4097C200.42 42.5197 202.79 40.4896 205.74 40.4896Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89 52.9696H178.62V43.3895H188.13V36.4596H178.62V27.0696H170.89V36.4596H161.47V43.3895H170.89V52.9696Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.02 250.16L31.1699 173.78L31.3599 33.7297L163.22 110.1L163.02 250.16Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16 154.73L31.2998 78.3497L31.3597 33.7297L163.22 110.1L163.16 154.73Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3297 115.07L41.5298 102.44L41.5597 81.3696L63.3597 93.9896L63.3297 115.07Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1699 132.35L71.3599 119.72L71.3899 98.6497L93.1998 111.27L93.1699 132.35Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 149.63L101.2 137L101.23 115.93L123.03 128.55L123 149.63Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84 166.91L131.04 154.29L131.06 133.21L152.87 145.84L152.84 166.91Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2998 141.88L41.4897 129.25L41.5198 108.17L63.3297 120.8L63.2998 141.88Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1299 159.16L71.3298 146.53L71.3599 125.45L93.1599 138.08L93.1299 159.16Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.97 176.44L101.16 163.81L101.19 142.73L122.99 155.36L122.97 176.44Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8 193.72L131 181.09L131.03 160.01L152.83 172.64L152.8 193.72Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2598 168.69L41.4497 156.06L41.4797 134.98L63.2898 147.61L63.2598 168.69Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.09 185.97L71.29 173.34L71.3199 152.26L93.12 164.89L93.09 185.97Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.93 203.25L101.13 190.62L101.16 169.54L122.96 182.17L122.93 203.25Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53 100.69L163.22 110.1L163.02 250.16L179.34 240.75L179.53 100.69Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6699 24.3196L31.3599 33.7296L163.22 110.1L179.53 100.69L47.6699 24.3196Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.99 124.13C126.76 121.1 122.51 113.73 122.52 107.69L122.54 91.6798C122.54 88.6598 123.61 86.5398 125.33 85.5598C127.05 84.5698 129.42 84.7199 132.04 86.2299C137.27 89.2599 141.52 96.6298 141.51 102.67L141.49 118.68C141.49 121.7 140.42 123.81 138.7 124.8C136.98 125.79 134.6 125.64 131.99 124.13Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.68 86.9898C168.68 80.9598 164.44 73.5798 159.21 70.5498C156.59 69.0298 154.21 68.8898 152.49 69.8798L130.78 82.4298L125.33 85.5598C127.05 84.5698 129.42 84.7199 132.04 86.2299C137.27 89.2599 141.52 96.6298 141.51 102.67L141.49 118.68C141.49 121.7 140.42 123.81 138.7 124.8L144.16 121.66C145.88 120.67 146.95 118.55 146.95 115.54L146.97 99.5398V100.67L163.27 91.2498L168.68 94.3898V88.1298V86.9998V86.9898Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5898 77.5999C46.3598 74.5699 42.1199 67.1998 42.1199 61.1698L42.1399 45.1598C42.1399 42.1398 43.2099 40.0198 44.9299 39.0398C46.6499 38.0498 49.0199 38.1999 51.6399 39.7099C56.8699 42.7399 61.1199 50.1098 61.1099 56.1498L61.0898 72.1598C61.0898 75.1698 60.0199 77.2898 58.2999 78.2798C56.5799 79.2698 54.1998 79.1198 51.5898 77.6098V77.5999Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8098 24.0198C76.1898 22.4998 73.8098 22.3599 72.0898 23.3499L50.3799 35.8998L44.9299 39.0298C46.6499 38.0398 49.0199 38.1899 51.6399 39.6999C56.8699 42.7299 61.1199 50.0998 61.1099 56.1398L61.0898 72.1498C61.0898 75.1598 60.0199 77.2798 58.2999 78.2698L63.7599 75.1298C65.4799 74.1398 66.5399 72.0198 66.5499 69.0098L66.5698 54.1298L82.8699 44.7099L88.2799 47.8698V40.4399C88.2899 34.4099 84.0398 27.0298 78.8098 23.9998V24.0198Z",
    fill: "#29A063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_1437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(0.109863 0.159668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemps4);
export default __webpack_public_path__ + "static/media/temps4.e6444b6fc83c2fd713aacfdc24f6fb48.svg";
export { ForwardRef as ReactComponent };